/* eslint-disable filename-export/match-default-export */
import { isConnectionUpload, isPlaybookUpload } from './UPLOAD_TYPE';

const preventUpload = (uploadType, extension, result, playbookState, clusterId) => {
  const extensions = ['json', 'yml', 'yaml'];
  const connectionType = Object.keys(playbookState.connectionJSON)[0];

  if (extensions.indexOf(extension) === -1) {
    return `This file type isn't supported. We only support JSON or YAML files. Please upload a file in one of these formats.`;
  }

  // check if the file is invalid format(eg pipeline)
  const { writeKey, integrations, connection, endpointSchema, integrationName, pipelines } = result;
  if (writeKey || integrations || connection || endpointSchema || integrationName || pipelines) {
    return `This file doesn't match the expected format. Your file includes unexpected fields and can't be processed. Please check the required structure and try again.`;
  }

  const { version } = result;

  if (isPlaybookUpload(uploadType) && !version) {
    return `Version field is missing. Every playbook file needs a version field. Please add it and upload the file again.`;
  }

  // SDK connection kits
  if (!version && connectionType === 'connectionTemplate' && isConnectionUpload(uploadType)) {
    return `This SDK connection can't be edited. SDK connections of type connectionTemplate require a version field. If you need to update it, please check the documentation.`;
  }

  if (!version && connectionType === 'endpointSchema' && isConnectionUpload(uploadType)) {
    // HTTP, make sure default field exists
    if (result.default === undefined) {
      return `Missing required fields in endpoint schema. Your file is missing the version and default fields, which are required for this type of connection. Please update the file and try again.`;
    }
  }

  if (!clusterId) {
    return `No available clusters found. You need at least one available cluster to proceed. Please set up a cluster and try again.`;
  }

  return null;
};

export default preventUpload;
